import React, { Component } from 'react'
import { Button, Container, Col, Row, Label, Modal, ModalBody } from 'reactstrap'
import FiltroConsulta from '../components/FiltroConsulta'
import TabelaConsulta from '../components/TabelaConsulta'
import { observer, inject } from 'mobx-react'
import DataWrapper from '../../../principal/containers/DataWrapper'
import ConsultaStore from '../stores/ConsultaStore'
import Footer from '../../../comum/components/Footer'
import FooterContent from '../../../comum/components/FooterContent'
import ModalAviso from '../../../comum/components/ModalAviso'
import ModalForm from '../../../comum/components/ModalForm'
import ModalPix from '../../../comum/components/ModalPix'
import ModalDetalhes from '../components/ModalDetalhes'
import RadiobuttonGroup from '../../../comum/components/RadiobuttonGroup'
import { OrcamentoExport } from '../../orcamento/exportacao/telas/OrcamentoExport'
import { OrcamentoImport } from '../../orcamento/importacao/telas/OrcamentoImport'
import ModalDetalhesMobile from '../components/ModalDetalhesMobile'
import LoadingImage from '../../../comum/components/LoadingImage'
import lscache from "lscache"
import ImgPopupRIG from "../../../../assets/images/RIG/popup_orc.png";

@inject('store')
@DataWrapper
@observer
export class ConsultaOrcamento extends Component {

    constructor(props) {
        super(props)

        this.tituloPaginaStore = this.props.store.tituloPaginaStore
        this.loginStore = this.props.store.loginStore

        let voltarParam = _.get(this.props.location.state,`voltar`);
        voltarParam ? lscache.set('acompProcesso-pesquisa-voltar', 5) : false;
        this.props.store.appStore.showVoltarTopBar(voltarParam ? true : false, voltarParam ? voltarParam : '/');

        this.controller = new ConsultaStore()
        this.state = { modalPopup: true };
    }

    can = (operacao = "C", tarefa = "OrcamentoWeb") => this.loginStore.can(tarefa, operacao)

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Orçamentos")
    }

    modalAviso() {
        return this.controller.mensagem !== "" && <ModalAviso
            onClickFechar={this.controller.fecharModalMensagem}
        >
            <h2>{this.controller.mensagem}</h2>
        </ModalAviso>
    }

    modalCancelar() {
        return this.controller.modalCancelar && <ModalForm
            salvando={this.controller.loadingCancelar}
            onClickSalvar={this.controller.cancelarOrcamento}
            labelConfirmar="CONFIRMAR"
            labelCancelar="FECHAR"
            onClickCancelar={() => this.controller.toggleModal(null, null, "cancelar", false)}
        >
            <h2>Deseja mesmo cancelar o orçamento?</h2>
        </ModalForm>
    }

    modalAlerta() {
        if (this.controller.modalAlerta)            
            return <ModalForm   className="tamanho-modal-acomproc" 
                                esconderSalvar={true}
                                salvando={this.controller.salvando}
                                onClickCancelar={this.controller.redirecionarOrcamento}                                
                                labelCancelar="FECHAR" 
                    >
                                <Label className="label-lg-black">ATENÇÃO!</Label>
                                <p />
                                <p className="text-desistencia">
                                    Ao clicar na opção "Incluir data de retirada no cálculo do valor de armazenagem", o cliente:
                                </p>
                <p className="text-desistencia">
                    <strong>
                        1- Paga o dia de retirada informado, quando esta data for o primeiro dia após o período livre;
                                        <br />
                        <br />
                        2- Paga o complemento de armazenagem referente ao "dia de porta" ou mais dias.
                                    </strong>
                </p>
            </ModalForm>

    };

    modalTempSSA() {
            return this.controller.modalTempSSA && 
            <ModalForm   className="tamanho-modal-acomproc" 
                                esconderSalvar={true}
                                onClickCancelar={() => this.controller.modalTempSSA = false}                                
                                labelCancelar="FECHAR" 
                    >
                                <p className="text-desistencia">
                                <h1><strong>Atenção! 🚨</strong></h1>
                                Aviso Importante <br/>
                                    Prezados(as) clientes,<br/>
                                    Informamos que estamos realizando ajustes sistêmicos nos orçamentos, em decorrência das adequações previstas pela Reforma Tributária, conforme estabelecido na Lei Complementar nº 214/2025, que define as novas regras do IBS e da CBS, com vigência a partir de 2026. <br/>
                                    Em razão desses ajustes, foi necessária a suspensão temporária da funcionalidade de demonstrativo de cálculo no portal.<br/>
                                    Durante esse período, solicitamos que entrem em contato diretamente com nossa equipe de atendimento por e-mail atendimento.tcsv@wilsonsons.com.br para solicitação de orçamentos, o que poderá ocasionar um prazo de retorno superior ao habitual.<br/>
                                    Agradecemos desde já pela compreensão e permanecemos à disposição para quaisquer esclarecimentos.          
                                </p>
            </ModalForm>
        }

    modalDemonstrativo() {
        if(this.controller.loadingDemonstrativo) {
            return (
                <ModalAviso
                    onClickFechar={() => {this.controller.loadingDemonstrativo = false}}
                >
                    <h2>
                        Processando
                    </h2>
                    <LoadingImage />
                </ModalAviso>
            )
        }
    }

    modalDetalhes() {
        if (this.controller.modalDetalhes) {
            if (window.innerWidth > 991) {
                return <ModalDetalhes controller={this.controller} />
            } else {
                return <ModalDetalhesMobile controller={this.controller} />
            }
        }
    }

    modalNovoOrcamento() {
        return this.controller.modalNovoOrcamento && 
        <ModalForm
            labelConfirmar="CONTINUAR"
            onClickSalvar={this.controller.mostrarAlerta}
            className="tamanho-modal-500"
            onClickCancelar={this.controller.fecharModalNovoOrcamento}
            habilitaSalvar={(this.controller.tipoOrc != "")}
        >            
            <Row className="mb-0">
                <h2 className="ml-3">Novo Orçamento</h2>
                <RadiobuttonGroup
                    xs={12} sm={12} md={12} lg={12} xl={12}
                    onClick={this.controller.mudarNovoOrcamento}
                    titulo="Tipo de orçamento"
                    name="tipoOrc"
                    obrigatorio={true}
                    itens={[
                        {id:"Imp", label:"Importação", value:"imp", checked:this.controller.tipoOrc === 'imp'},
                        {id:"Exp", label:"Exportação", value:"exp", checked:this.controller.tipoOrc === 'exp'},
                    ]}
                />
            </Row>
            {this.controller.tipoOrc === "" ?
                <Label className="label-danger ml-1 mb-0">Selecione uma das opções</Label>
                : 
                <div />
            }
        </ModalForm>
    }

    
    renderModalPagamentoPix() {
        return this.controller.modalPagamentoPix && 
        <ModalPix 
            controller={this.controller}
            valorTotal={this.controller.valorTotal}
            dataPix={this.controller.dataPix} 
        />    
    }

    toggle = () => this.setState({ modalPopup: !this.state.modalPopup });
    popupAviso = () => (
        process.env.rig &&
        <Modal
            isOpen={this.state.modalPopup}
            toggle={this.toggle}
            keyboard={true}
            size="lg"
            centered={true}
        >
            <ModalBody>
              <img src={ImgPopupRIG} alt="Popup" className="img-fluid" />
            </ModalBody>
        </Modal>
    )

    render() {
        //this.controller.telaImport
        if (this.controller.telaImport) {
            if (this.controller.naoGeraOrcamentoIndisponivel) {
                this.controller.telaImport = false;
                {this.modalTempSSA()}
            }
            return <OrcamentoImport controller={this.controller} />
        } else if (this.controller.telaExport) {
            if (this.controller.naoGeraOrcamentoIndisponivel) {
                this.controller.telaExport = false;
                {this.modalTempSSA()}
            }
            return <OrcamentoExport controller={this.controller} />
        } else {
            return (
                <div className="form-wrapper">
                    {/* {this.popupAviso()} 19/01 - Retirado pop-up de aviso dos orçamentos */}
                    {this.modalAviso()}
                    {this.modalTempSSA()}
                    {this.modalDemonstrativo()}
                    {this.renderModalPagamentoPix()}
                    {this.can("I") && this.modalNovoOrcamento()}
                    {this.modalAlerta()}
                    {this.can("E") && this.modalCancelar()}
                    {this.can("C") && this.modalDetalhes()}
                    <Container fluid className="liberacao-cabotagem tela-botoes-inclusao-topo">
                        <Row className="botoes-inclusao-topo">
                            {this.can("I") &&
                                <Col xs={12} sm={12} md={12}>
                                    {
                                        process.env.rig
                                            ? <Button onClick={this.controller.abrirModalNovoOrcamento} className="btn-com-bordas-primary">
                                                Novo Orçamento
                                    </Button>
                                            : <Button onClick={() => { this.controller.tipoOrc = "imp"; this.controller.redirecionarOrcamento() }} className="btn-com-bordas-primary">
                                                Novo Orçamento
                                    </Button>
                                    }
                                </Col>
                            }
                        </Row>
                        <FiltroConsulta controller={this.controller} />
                        <TabelaConsulta controller={this.controller} />
                    </Container>
                    <Footer>
                        <FooterContent>
                            {
                                this.controller.filtrado
                                    ? <React.Fragment>
                                        <b className="mr-1">
                                            {this.controller.itens.length}
                                        </b>
                                        Orçamentos encontrados
                                        -
                                    <Button className="btn-primary px-0" onClick={this.controller.listar}>Atualizar lista</Button>
                                    </React.Fragment>
                                    : null
                            }
                        </FooterContent>
                    </Footer>
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/consulta/telas/ConsultaOrcamento.js